'use client';

import * as React from 'react';
import { motion, useAnimation, Variants } from 'framer-motion';

const pathVariants: Variants = {
	normal: {
		pathLength: 1,
		opacity: 1,
		pathOffset: 0,
	},
	animate: {
		opacity: [0, 1],
		pathLength: [0, 1],
		transition: {
			delay: 0.1,
			duration: 0.4,
			opacity: { duration: 0.1, delay: 0.1 },
		},
	},
};

export function FlameIcon({ isHovered }: { isHovered: boolean }) {
	const controls = useAnimation();

	React.useEffect(() => {
		void controls.start(isHovered ? 'animate' : 'normal');
	}, [isHovered, controls]);

	return (
		<div className='select-none p-2 flex items-center justify-center'>
			<svg
				xmlns='http://www.w3.org/2000/svg'
				width='24'
				height='24'
				viewBox='0 0 24 24'
				fill='none'
				stroke={isHovered ? '#FF69B4' : 'currentColor'}
				strokeWidth='2'
				strokeLinecap='round'
				strokeLinejoin='round'
				className={`transition-transform duration-200 ${
					isHovered ? 'scale-110' : ''
				}`}
			>
				<motion.path
					variants={pathVariants}
					initial='normal'
					animate={controls}
					d='M8.9 14.5A2.5 2.5 0 0 0 11 12c0-1.38-.5-2-1-3-1.072-2.143-.224-4.054 2-6 .5 2.5 2 4.9 4 6.5 2 1.6 3 3.5 3 5.5a7 7 0 1 1-14 0c0-1.153.433-2.294 1-3a2.5 2.5 0 0 0 2.5 2.5z'
				/>
			</svg>
		</div>
	);
}
